import { gql } from '@apollo/client';
import { BizAoiProduceResult, PRODUCE_RESULT_FIELDS } from './produceResult';

/**
 * 删除 AOI (二次确认后调用)。
 */
export const DELETE_BIZ_AOI = gql`
  mutation DeleteBizAoi($input: BizAoiDeleteInput!) {
    deleteBizAoi(input: $input) {
${PRODUCE_RESULT_FIELDS}
    }
  }
`;

export interface BizAoiDeleteInput {
    aoiId: number;
    zipcode: string;
}

export interface DeleteBizAoiResponse {
    deleteBizAoi: BizAoiProduceResult;
}
